import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ISetupStatusResponse } from '../models/setup-status.model';

export const regulationVerifiedFeatureKey = 'regulationVerified';

export interface RegulationVerifiedState {
  loadRegulationVerifiedResponse: ISetupStatusResponse;
}

export const initialState: RegulationVerifiedState = {
  loadRegulationVerifiedResponse: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadRegulationVerifiedSuccess, (state, action) => ({
    ...state,
    loadRegulationVerifiedResponse: action.response
  }))
);

export const getIsRegulationVerified = (state: RegulationVerifiedState) => state.loadRegulationVerifiedResponse;
